import { analyticsService } from "@/common/services/analytics/analytics.service";
import { MegaMenuItemData } from "@/common/contracts/mega-menu.contracts";
import { useMegaMenuState } from "@/components/mega-menu/MegaMenuProvider";
import { LinkButton } from "@/ui/next/LinkButton";
import {
  NavigationMenuItem,
  NavigationMenuLink,
} from "@radix-ui/react-navigation-menu";

type MegaMenuSeeAllItemProps = {
  item?: MegaMenuItemData;
};

export const MegaMenuSeeAllItem = ({ item }: MegaMenuSeeAllItemProps) => {
  const { hideMenu } = useMegaMenuState();

  const handleClick = () => {
    /** Trigger `navigation_menu` event. */
    analyticsService.trackNavigationMenu(item?.label);
  };

  if (!item?.href) {
    return null;
  }

  return (
    <ul>
      <NavigationMenuItem className="flex">
        <NavigationMenuLink asChild onSelect={hideMenu}>
          <LinkButton
            size="large"
            appearance="minimal"
            href={item.href}
            onClick={handleClick}
          >
            {item.label}
          </LinkButton>
        </NavigationMenuLink>
      </NavigationMenuItem>
    </ul>
  );
};
